
// import React, { useEffect, useMemo, useState, useCallback, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Search, RefreshCw, AlertCircle, Loader2, X, Users, ChevronLeft, ChevronRight } from 'lucide-react';

// import {
//   GetApprovedLeave,
//   GetRejectedLeave,
//   GetCanceledLeave,
//   GetPendingLeave,
// } from '../../action/Leave';
// import LeaveService from '../../services/LeaveService';
// import { fetchAllEmployees } from '../../store/slices/employeeSlice';
// import toIsoDate from "../../utils/dateFormat";
// import Table, { TABLE_THEME } from '../../components/Table/Table';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;

// const STATUS_META = {
//   PENDING: 'bg-amber-50 text-amber-700',
//   APPROVED: 'bg-primary-50 text-primary-700',
//   REJECTED: 'bg-red-50 text-red-700',
//   CANCELLED: 'bg-gray-100 text-gray-500',
//   CANCELED: 'bg-gray-100 text-gray-500',
// };

// const statusClass = (s) => STATUS_META[(s || '').toUpperCase()] || 'bg-gray-100 text-gray-500';
// const statusLabel = (s) => {
//   const up = (s || '').toUpperCase();
//   if (up === 'CANCELED') return 'Cancelled';
//   return up ? up.charAt(0) + up.slice(1).toLowerCase() : '—';
// };

// const g = (leave, key) => {
//   const v = leave?.[key];
//   return (!v || v === 'null') ? '' : String(v).trim();
// };

// const getFormNo = (l) => g(l, 'HLF_FORM_NO');
// const getServiceNo = (l) => g(l, 'HLF_EMP_SERVICE_NO');
// const getTypeId = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
// const getFromDate = (l) => g(l, 'HLF_FROM_DATE');
// const getToDate = (l) => g(l, 'HLF_TO_DATE');
// const getTotalDays = (l) => g(l, 'HLF_TOTAL_DAYS');
// const getStatus = (l) => g(l, 'HLF_STATUS');
// const getAppliedDate = (l) => g(l, 'HLF_APPLIED_DATE');

// const fmtDate = (v) => toIsoDate(v) || '—';

// const fmtEmp = (v) => (!v || v === 'null') ? '' : String(v).trim();

// const STATUS_TABS = [
//   { id: 'all', label: 'All' },
//   { id: 'PENDING', label: 'Pending' },
//   { id: 'APPROVED', label: 'Approved' },
//   { id: 'REJECTED', label: 'Rejected' },
// ];

// // Pagination constant
// const ROWS_PER_PAGE = 7;

// export default function LeaveHistory() {
//   const dispatch = useDispatch();
//   const { employees, loading: employeesLoading } = useSelector(s => s.employees || {});
//   const [records, setRecords] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [search, setSearch] = useState('');
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [statusTab, setStatusTab] = useState('all');
//   const [leaveTypeMap, setLeaveTypeMap] = useState({});
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [searchInput, setSearchInput] = useState('');
//   const dropdownRef = useRef(null);
//   const inputRef = useRef(null);

//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);

//   // Reset to page 1 when search or status tab changes
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [search, statusTab, selectedEmployee]);

//   // Fetch employees on mount
//   useEffect(() => {
//     if (!employees || employees.length === 0) {
//       dispatch(fetchAllEmployees());
//     }
//   }, [dispatch, employees]);

//   // Click outside handler for dropdown
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
//         inputRef.current && !inputRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Fetch leave types
//   useEffect(() => {
//     let cancelled = false;
//     LeaveService.GetLeaveTypeList()
//       .then(res => {
//         const rows = res?.data?.ResultSet || res?.data?.resultSet || [];
//         const map = {};
//         rows.forEach(r => {
//           const id = r.TYPE_ID ?? r.TypeId ?? r.typeId ?? r.p_typeId;
//           const name = r.TYPE_NAME ?? r.TypeName ?? r.typeName ?? r.p_typeName;
//           if (id != null) map[String(id)] = name;
//         });
//         if (!cancelled) setLeaveTypeMap(map);
//       })
//       .catch(() => { });
//     return () => { cancelled = true; };
//   }, []);

//   // Build employee map
//   const employeeMap = useMemo(() => {
//     const map = {};

//     if (!employees || !Array.isArray(employees)) {
//       return map;
//     }

//     employees.forEach(e => {
//       const sno = e.HED_SERVICE_NO || e.p_ced_service_no || e.serviceNo || e.employeeNo;
//       if (!sno) return;

//       let name = e.HED_REPORT_NAME || e.p_report_name || e.reportName;

//       if (!name) {
//         const firstName = e.HED_FIRST_NAME || e.p_first_name || e.firstName || '';
//         const lastName = e.HED_LAST_NAME || e.p_last_name || e.lastName || '';
//         const middleName = e.HED_MIDDLE_NAME || e.p_middle_name || e.middleName || '';

//         if (firstName && lastName) {
//           name = `${firstName} ${middleName} ${lastName}`.trim().replace(/\s+/g, ' ');
//         } else if (firstName) {
//           name = firstName;
//         } else {
//           name = String(sno);
//         }
//       }

//       map[String(sno)] = {
//         name: String(name).trim(),
//         serviceNo: String(sno),
//         employeeId: e.HED_EMPLOYEE_ID || e.p_hedEmployeeId || e.id || e.employeeId,
//         title: e.HED_TITLE || e.title || '',
//         initials: e.HED_INITIALS || e.initials || '',
//       };
//     });

//     return map;
//   }, [employees]);

//   // Get employees list with "All" option
//   const employeeList = useMemo(() => {
//     const list = Object.values(employeeMap);
//     list.sort((a, b) => a.name.localeCompare(b.name));
//     return list;
//   }, [employeeMap]);

//   // Filtered employees for dropdown
//   const filteredEmployees = useMemo(() => {
//     if (!searchInput.trim()) return employeeList;
//     const query = searchInput.toLowerCase().trim();
//     return employeeList.filter(emp =>
//       emp.name.toLowerCase().includes(query) ||
//       emp.serviceNo.toLowerCase().includes(query)
//     );
//   }, [employeeList, searchInput]);

//   const fetchAll = useCallback(() => {
//     setLoading(true);
//     setError('');
//     Promise.all([
//       dispatch(GetPendingLeave()).catch(() => []),
//       dispatch(GetApprovedLeave()).catch(() => []),
//       dispatch(GetRejectedLeave()).catch(() => []),
//       dispatch(GetCanceledLeave()).catch(() => []),
//     ])
//       .then(([pending, approved, rejected, canceled]) => {
//         const merged = [...pending, ...approved, ...rejected, ...canceled]
//           .filter(Boolean)
//           .filter(r => {
//             const status = getStatus(r).toUpperCase();
//             return status !== 'CANCELLED' && status !== 'CANCELED';
//           })
//           .sort((a, b) => new Date(getAppliedDate(b) || getFromDate(b)) - new Date(getAppliedDate(a) || getFromDate(a)));
//         setRecords(merged);
//       })
//       .catch(e => setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leave history')))
//       .finally(() => setLoading(false));
//   }, [dispatch]);

//   useEffect(() => { fetchAll(); }, [fetchAll]);

//   // Handle employee selection
//   const handleSelectEmployee = (emp) => {
//     if (emp && emp.id === 'all') {
//       setSelectedEmployee(null);
//       setSearchInput('');
//       setSearch('');
//       setShowDropdown(false);
//     } else if (emp) {
//       setSelectedEmployee(emp);
//       setSearchInput(emp.name);
//       setShowDropdown(false);
//       setSearch('');
//     }
//   };

//   // Handle clearing selection
//   const handleClearSelection = () => {
//     setSelectedEmployee(null);
//     setSearchInput('');
//     setSearch('');
//     setShowDropdown(false);
//   };

//   // Handle input change
//   const handleInputChange = (e) => {
//     const value = e.target.value;
//     setSearchInput(value);
//     setShowDropdown(true);

//     if (!value.trim()) {
//       setSelectedEmployee(null);
//       setSearch('');
//     }
//   };

//   // Filter records
//   const filtered = useMemo(() => {
//     let rows = records;

//     if (statusTab !== 'all') {
//       rows = rows.filter(r => getStatus(r).toUpperCase() === statusTab);
//     }

//     if (selectedEmployee) {
//       rows = rows.filter(r => getServiceNo(r) === selectedEmployee.serviceNo);
//     } else if (search.trim()) {
//       const q = search.trim().toLowerCase();
//       rows = rows.filter(r => {
//         const sno = getServiceNo(r).toLowerCase();
//         const empData = employeeMap[getServiceNo(r)];
//         const name = (empData?.name || '').toLowerCase();
//         return sno.includes(q) || name.includes(q);
//       });
//     }

//     return rows;
//   }, [records, statusTab, search, selectedEmployee, employeeMap]);

//   // Pagination calculations
//   const totalPages = Math.ceil(filtered.length / ROWS_PER_PAGE);
//   const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
//   const endIndex = startIndex + ROWS_PER_PAGE;
//   const currentItems = filtered.slice(startIndex, endIndex);

//   function handlePageChange(page) {
//     if (page >= 1 && page <= totalPages) {
//       setCurrentPage(page);
//     }
//   }

//   // ─── Table Columns ──────────────────────────────────────────────────
//   const leaveColumns = [
//     {
//       key: 'formNo',
//       label: 'Form',
//       className: 'text-gray-500 font-medium',
//       render: (r) => getFormNo(r)
//     },
//     {
//       key: 'Service no',
//       label: 'Service No',
//       className: 'text-gray-900',
//       render: (r) => {
//         const sno = getServiceNo(r);
//         const empData = employeeMap[sno];
//         return (
//           <div>
//             {/* <p className="font-medium text-gray-900">{empData?.name || sno || '—'}</p> */}
//             <p className="text-xs text-gray-400">{sno}</p>
//           </div>
//         );
//       }
//     },
//     {
//       key: 'employee',
//       label: 'Employee',
//       className: 'text-gray-900',
//       render: (r) => {
//         const sno = getServiceNo(r);
//         const empData = employeeMap[sno];
//         return (
//           <div>
//             <p className="font-medium text-gray-900">{empData?.name || sno || '—'}</p>
//           </div>
//         );
//       }
//     },
//     {
//       key: 'leaveType',
//       label: 'Leave Type',
//       className: 'text-gray-600',
//       render: (r) => {
//         const typeId = getTypeId(r);
//         return leaveTypeMap[typeId] || `Type #${typeId || '—'}`;
//       }
//     },
//     {
//       key: 'fromDate',
//       label: 'From',
//       className: 'text-gray-600',
//       render: (r) => fmtDate(getFromDate(r))
//     },
//     {
//       key: 'toDate',
//       label: 'To',
//       className: 'text-gray-600',
//       render: (r) => fmtDate(getToDate(r))
//     },
//     {
//       key: 'days',
//       label: 'Days',
//       className: 'text-gray-800 font-semibold',
//       render: (r) => getTotalDays(r) || '—'
//     },
//     {
//       key: 'status',
//       label: 'Status',
//       className: 'text-gray-600',
//       render: (r) => (
//         <span className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${statusClass(getStatus(r))}`}>
//           {statusLabel(getStatus(r))}
//         </span>
//       )
//     },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       {/* ── Page Header ─────────────────────────────────────────── */}
//       <div className="flex items-start justify-between flex-wrap gap-3">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">Leave History</h1>
//           <p className="mt-1 text-sm text-gray-500">
//             All past and pending leave requests, across every leave type and status.
//           </p>
//         </div>
//         <button
//           onClick={fetchAll}
//           disabled={loading}
//           className="flex shrink-0 items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700 transition-colors disabled:opacity-50"
//         >
//           <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
//           Refresh
//         </button>
//       </div>

//       {/* ── Filters ────────────────────────────────────────────── */}
//       <div className="flex flex-wrap items-end gap-4">
//         <div className="flex-1 min-w-[200px]">
//           <span className={LABEL}>Search Employee</span>
//           <div className="relative max-w-[400px]">
//             <Search
//               size={16}
//               className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//             />
//             <input
//               ref={inputRef}
//               type="text"
//               value={searchInput}
//               onChange={handleInputChange}
//               onFocus={() => setShowDropdown(true)}
//               placeholder="Search by name or ID..."
//               className={`${FIELD} w-full pl-10 pr-10`}
//             />

//             {employeesLoading && (
//               <div className="absolute right-3 top-1/2 -translate-y-1/2">
//                 <Loader2 size={16} className="animate-spin text-primary-500" />
//               </div>
//             )}

//             {/* Close button to clear employee selection */}
//             {selectedEmployee && !employeesLoading && (
//               <button
//                 onClick={handleClearSelection}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full p-0.5 transition-colors"
//                 aria-label="Clear employee selection"
//                 title="Clear selection"
//               >
//                 <X size={16} />
//               </button>
//             )}

//             {/* Dropdown */}
//             {showDropdown && (
//               <div ref={dropdownRef} className="absolute z-50 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
//                 {/* "All" option */}
//                 <button
//                   onClick={() => handleSelectEmployee({ id: 'all', name: 'All Employees', serviceNo: 'all' })}
//                   className="w-full px-4 py-2.5 text-left hover:bg-primary-50 transition-colors flex items-center gap-2 border-b border-gray-100"
//                 >
//                   <Users size={16} className="text-primary-500" />
//                   <span className="font-medium text-gray-800">All Employees</span>
//                   <span className="text-xs text-gray-400 ml-auto">View all</span>
//                 </button>

//                 {filteredEmployees.length === 0 ? (
//                   <div className="px-4 py-3 text-sm text-gray-400">No employees found</div>
//                 ) : (
//                   filteredEmployees.map((emp) => (
//                     <button
//                       key={emp.serviceNo}
//                       onClick={() => handleSelectEmployee(emp)}
//                       className="w-full px-4 py-2.5 text-left hover:bg-primary-50 transition-colors flex items-center justify-between"
//                     >
//                       <span className="font-medium text-gray-800">{emp.name}</span>
//                       <span className="text-xs text-gray-400">{emp.serviceNo}</span>
//                     </button>
//                   ))
//                 )}
//               </div>
//             )}
//           </div>
//         </div>

//         <div>
//           <span className={LABEL}>Status</span>
//           <div className="flex gap-1 flex-wrap">
//             {STATUS_TABS.map(t => (
//               <button
//                 key={t.id}
//                 onClick={() => setStatusTab(t.id)}
//                 className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors
//             ${statusTab === t.id
//                     ? 'bg-primary-600 text-white'
//                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//                   }`}
//               >
//                 {t.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* ── Error Display ─────────────────────────────────────────── */}
//       {error && (
//         <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
//           <AlertCircle size={16} />
//           {error}
//         </div>
//       )}

//       {/* ── Table ────────────────────────────────────────────────────── */}
//       <Table
//         columns={leaveColumns}
//         rows={currentItems}
//         rowKey={(r) => `${getFormNo(r)}-${getServiceNo(r)}`}
//         loading={loading}
//         loadingMessage="Loading leave history..."
//         emptyMessage={
//           selectedEmployee
//             ? `No leave history found for ${selectedEmployee.name}`
//             : search
//               ? 'No leave history matches your search criteria.'
//               : 'No leave history available.'
//         }
//         minWidth={820}
//         scrollClassName=""
//         emptyValue="-"
//         defaultSort={{ key: 'fromDate', dir: 'desc' }}
//       />

//       {/* ── Pagination ────────────────────────────────────────────── */}
//       {!loading && !error && filtered.length > 0 && (
//         <div className="flex items-center justify-between border-t border-gray-200 px-5 py-4">
//           <div className="text-sm text-gray-500">
//             Showing {startIndex + 1} to {Math.min(endIndex, filtered.length)} of {filtered.length} entries
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={() => handlePageChange(currentPage - 1)}
//               disabled={currentPage === 1}
//               className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
//               aria-label="Previous page"
//             >
//               <ChevronLeft size={16} />
//             </button>

//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNum;
//               if (totalPages <= 5) {
//                 pageNum = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNum = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNum = totalPages - 4 + i;
//               } else {
//                 pageNum = currentPage - 2 + i;
//               }

//               return (
//                 <button
//                   key={pageNum}
//                   onClick={() => handlePageChange(pageNum)}
//                   className={`h-8 min-w-8 rounded-md px-2 text-sm font-medium ${currentPage === pageNum
//                       ? 'bg-primary-600 text-white'
//                       : 'text-gray-700 hover:bg-surface-50'
//                     }`}
//                 >
//                   {pageNum}
//                 </button>
//               );
//             })}

//             <button
//               onClick={() => handlePageChange(currentPage + 1)}
//               disabled={currentPage === totalPages}
//               className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
//               aria-label="Next page"
//             >
//               <ChevronRight size={16} />
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RefreshCw, AlertCircle, Loader2, ChevronLeft, ChevronRight } from 'lucide-react';

import EmployeeSearch from '../../components/common/EmployeeSearch';
import { fetchLeaveRequestsByStatus } from '../../store/slices/leaveSlice';
import {
  PENDING_LEAVE_STATUS,
  APPROVED_LEAVE_STATUS,
  REJECT_LEAVE_STATUS,
  CANCEL_LEAVE_STATUS,
} from '../../constants/leaveConstent';
import LeaveService from '../../services/LeaveService';
import { fetchAllEmployees } from '../../store/slices/employeeSlice';
import toIsoDate from "../../utils/dateFormat";
import Table, { TABLE_THEME } from '../../components/Table/Table';

const LABEL = TABLE_THEME.fieldLabel;

const STATUS_META = {
  PENDING: 'bg-amber-50 text-amber-700',
  APPROVED: 'bg-primary-50 text-primary-700',
  REJECTED: 'bg-red-50 text-red-700',
  CANCELLED: 'bg-gray-100 text-gray-500',
  CANCELED: 'bg-gray-100 text-gray-500',
};

const statusClass = (s) => STATUS_META[(s || '').toUpperCase()] || 'bg-gray-100 text-gray-500';
const statusLabel = (s) => {
  const up = (s || '').toUpperCase();
  if (up === 'CANCELED') return 'Cancelled';
  return up ? up.charAt(0) + up.slice(1).toLowerCase() : '—';
};

const g = (leave, key) => {
  const v = leave?.[key];
  return (!v || v === 'null') ? '' : String(v).trim();
};

const getFormNo = (l) => g(l, 'HLF_FORM_NO');
const getServiceNo = (l) => g(l, 'HLF_EMP_SERVICE_NO');
const getTypeId = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
const getFromDate = (l) => g(l, 'HLF_FROM_DATE');
const getToDate = (l) => g(l, 'HLF_TO_DATE');
const getTotalDays = (l) => g(l, 'HLF_TOTAL_DAYS');
const getStatus = (l) => g(l, 'HLF_STATUS');
const getAppliedDate = (l) => g(l, 'HLF_APPLIED_DATE');

const fmtDate = (v) => toIsoDate(v) || '—';

const STATUS_TABS = [
  { id: 'all', label: 'All' },
  { id: 'PENDING', label: 'Pending' },
  { id: 'APPROVED', label: 'Approved' },
  { id: 'REJECTED', label: 'Rejected' },
];

// Pagination constant
const ROWS_PER_PAGE = 7;

export default function LeaveHistory() {
  const dispatch = useDispatch();
  const { employees, loading: employeesLoading } = useSelector(s => s.employees || {});
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState({
    employeeId: '__ALL__',
    name: 'All Employees',
    isAll: true,
  });
  const [statusTab, setStatusTab] = useState('PENDING');
  const [leaveTypeMap, setLeaveTypeMap] = useState({});

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);

  // Reset to page 1 when status tab or employee changes
  useEffect(() => {
    setCurrentPage(1);
  }, [statusTab, selectedEmployee?.serviceNo, selectedEmployee?.isAll]);

  // Fetch employees on mount
  useEffect(() => {
    if (!employees || employees.length === 0) {
      dispatch(fetchAllEmployees());
    }
  }, [dispatch, employees]);

  // Fetch leave types
  useEffect(() => {
    let cancelled = false;
    LeaveService.GetLeaveTypeList()
      .then(res => {
        const rows =
          res?.data?.ResultSet ||
          res?.data?.resultSet ||
          res?.ResultSet ||
          res?.resultSet ||
          (Array.isArray(res?.data) ? res.data : []) ||
          (Array.isArray(res) ? res : []);

        const map = {};
        rows.forEach(r => {
          const id =
            r.TYPE_ID ?? r.TypeId ?? r.typeId ?? r.p_typeId ??
            r.HLT_LEAVE_TYPE_ID ?? r.HLT_TYPE_ID ?? r.ID ?? r.id;
          const name =
            r.TYPE_NAME ?? r.TypeName ?? r.typeName ?? r.p_typeName ??
            r.HLT_NAME ?? r.HLT_TYPE_NAME ?? r.NAME ?? r.name;
          if (id != null && name) map[String(id)] = name;
        });

        if (!cancelled) setLeaveTypeMap(map);
      })
      .catch(err => {
        console.error('Leave type fetch failed:', err?.response?.status, err?.message);
      });
    return () => { cancelled = true; };
  }, []);

  // Build employee map (kept for the table column renderer)
  const employeeMap = useMemo(() => {
    const map = {};

    if (!employees || !Array.isArray(employees)) {
      return map;
    }

    employees.forEach(e => {
      const sno = e.HED_SERVICE_NO || e.p_ced_service_no || e.serviceNo || e.employeeNo;
      if (!sno) return;

      let name = e.HED_REPORT_NAME || e.p_report_name || e.reportName;

      if (!name) {
        const firstName = e.HED_FIRST_NAME || e.p_first_name || e.firstName || '';
        const lastName = e.HED_LAST_NAME || e.p_last_name || e.lastName || '';
        const middleName = e.HED_MIDDLE_NAME || e.p_middle_name || e.middleName || '';

        if (firstName && lastName) {
          name = `${firstName} ${middleName} ${lastName}`.trim().replace(/\s+/g, ' ');
        } else if (firstName) {
          name = firstName;
        } else {
          name = String(sno);
        }
      }

      map[String(sno)] = {
        name: String(name).trim(),
        serviceNo: String(sno),
        employeeId: e.HED_EMPLOYEE_ID || e.p_hedEmployeeId || e.id || e.employeeId,
        title: e.HED_TITLE || e.title || '',
        initials: e.HED_INITIALS || e.initials || '',
      };
    });

    return map;
  }, [employees]);

  // Normalize employees for the shared EmployeeSearch component
  const employeeOptions = useMemo(() => {
    if (!Array.isArray(employees)) return [];

    return employees
      .map((emp) => {
        const serviceNo =
          emp.HED_SERVICE_NO ||
          emp.p_ced_service_no ||
          emp.HED_CED_SERVICE_NO ||
          emp.serviceNo ||
          emp.employeeNo ||
          '';

        const name =
          emp.HED_REPORT_NAME ||
          emp.p_report_name ||
          emp.reportName ||
          `${emp.HED_FIRST_NAME || emp.p_first_name || emp.firstName || ''} ${emp.HED_LAST_NAME || emp.p_last_name || emp.lastName || ''}`.trim() ||
          'Unnamed Employee';

        return {
          employeeId: String(serviceNo || emp.HED_EMPLOYEE_ID || emp.employeeId || ''),
          serviceNo: String(serviceNo),
          name,
          department:
            emp.p_department_name ||
            emp.HDD_DEPARTMENT_NAME ||
            '',
        };
      })
      .filter((e) => e.employeeId);
  }, [employees]);

  const fetchAll = useCallback(() => {
    setLoading(true);
    setError('');
    Promise.all([
      dispatch(fetchLeaveRequestsByStatus(PENDING_LEAVE_STATUS)).unwrap().catch(() => []),
      dispatch(fetchLeaveRequestsByStatus(APPROVED_LEAVE_STATUS)).unwrap().catch(() => []),
      dispatch(fetchLeaveRequestsByStatus(REJECT_LEAVE_STATUS)).unwrap().catch(() => []),
      dispatch(fetchLeaveRequestsByStatus(CANCEL_LEAVE_STATUS)).unwrap().catch(() => []),
    ])
      .then(([pending, approved, rejected, canceled]) => {
        const merged = [...pending, ...approved, ...rejected, ...canceled]
          .filter(Boolean)
          .filter(r => {
            const status = getStatus(r).toUpperCase();
            return status !== 'CANCELLED' && status !== 'CANCELED';
          })
          .sort((a, b) => new Date(getAppliedDate(b) || getFromDate(b)) - new Date(getAppliedDate(a) || getFromDate(a)));
        setRecords(merged);
      })
      .catch(e => setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leave history')))
      .finally(() => setLoading(false));
  }, [dispatch]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  // Handle employee selection from shared component
  const handleEmployeeSelect = (employee) => {
    if (!employee) {
      setSelectedEmployee({
        employeeId: '__ALL__',
        name: 'All Employees',
        isAll: true,
      });
    } else {
      setSelectedEmployee(employee);
    }
  };

  // Filter records
  const filtered = useMemo(() => {
    let rows = records;

    if (statusTab !== 'all') {
      rows = rows.filter(r => getStatus(r).toUpperCase() === statusTab);
    }

    if (selectedEmployee && !selectedEmployee.isAll) {
      rows = rows.filter(r => getServiceNo(r) === selectedEmployee.serviceNo);
    }

    return rows;
  }, [records, statusTab, selectedEmployee]);

  // Pagination calculations
  const totalPages = Math.ceil(filtered.length / ROWS_PER_PAGE);
  const startIndex = (currentPage - 1) * ROWS_PER_PAGE;
  const endIndex = startIndex + ROWS_PER_PAGE;
  const currentItems = filtered.slice(startIndex, endIndex);

  function handlePageChange(page) {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  }

  // ─── Table Columns ──────────────────────────────────────────────────
  const leaveColumns = [
    {
      key: 'formNo',
      label: 'Form',
      className: 'text-gray-500 font-medium',
      render: (r) => getFormNo(r),
    },
    {
      key: 'Service no',
      label: 'Service No',
      className: 'text-gray-900',
      render: (r) => {
        const sno = getServiceNo(r);
        return (
          <div>
            <p className="text-xs text-gray-400">{sno}</p>
          </div>
        );
      },
    },
    {
      key: 'employee',
      label: 'Employee',
      className: 'text-gray-900',
      render: (r) => {
        const sno = getServiceNo(r);
        const empData = employeeMap[sno];
        return (
          <div>
            <p className="font-medium text-gray-900">{empData?.name || sno || '—'}</p>
          </div>
        );
      },
    },
    {
      key: 'leaveType',
      label: 'Leave Type',
      className: 'text-gray-600',
      render: (r) => {
        const typeId = getTypeId(r);
        return leaveTypeMap[typeId] || `Type #${typeId || '—'}`;
      },
    },
    {
      key: 'fromDate',
      label: 'From',
      className: 'text-gray-600',
      render: (r) => fmtDate(getFromDate(r)),
    },
    {
      key: 'toDate',
      label: 'To',
      className: 'text-gray-600',
      render: (r) => fmtDate(getToDate(r)),
    },
    {
      key: 'days',
      label: 'Days',
      className: 'text-gray-800 font-semibold',
      render: (r) => getTotalDays(r) || '—',
    },
    {
      key: 'status',
      label: 'Status',
      className: 'text-gray-600',
      render: (r) => (
        <span className={`inline-block rounded-full px-3 py-1 text-xs font-medium ${statusClass(getStatus(r))}`}>
          {statusLabel(getStatus(r))}
        </span>
      ),
    },
  ];

  return (
    <div className="p-6 space-y-4">
      {/* ── Page Header ─────────────────────────────────────────── */}
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Leave History</h1>
          <p className="mt-1 text-sm text-gray-500">
            All past and pending leave requests, across every leave type and status.
          </p>
        </div>
        <button
          onClick={fetchAll}
          disabled={loading}
          className="flex shrink-0 items-center gap-2 rounded-lg bg-primary-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-primary-700 transition-colors disabled:opacity-50"
        >
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
          Refresh
        </button>
      </div>

      {/* ── Filters ────────────────────────────────────────────── */}
      <div className="flex flex-wrap items-end gap-4">
        <div className="flex-1 min-w-[240px] max-w-[400px]">
          <span className={LABEL}>Search Employee</span>
          <EmployeeSearch
            value={selectedEmployee}
            onSelect={handleEmployeeSelect}
            employees={employeeOptions}
            loading={employeesLoading}
            showAllOption
          />
        </div>

        <div>
          <span className={LABEL}>Status</span>
          <div className="flex gap-1 flex-wrap">
            {STATUS_TABS.map(t => (
              <button
                key={t.id}
                onClick={() => setStatusTab(t.id)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition-colors
                  ${statusTab === t.id
                    ? 'bg-primary-600 text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ── Error Display ─────────────────────────────────────────── */}
      {error && (
        <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
          <AlertCircle size={16} />
          {error}
        </div>
      )}

      {/* ── Table ────────────────────────────────────────────────────── */}
      <Table
        columns={leaveColumns}
        rows={currentItems}
        rowKey={(r) => `${getFormNo(r)}-${getServiceNo(r)}`}
        loading={loading}
        loadingMessage="Loading leave history..."
        emptyMessage={
          selectedEmployee && !selectedEmployee.isAll
            ? `No leave history found for ${selectedEmployee.name}`
            : 'No leave history available.'
        }
        minWidth={820}
        scrollClassName=""
        emptyValue="-"
        defaultSort={{ key: 'fromDate', dir: 'desc' }}
      />

      {/* ── Pagination ────────────────────────────────────────────── */}
      {!loading && !error && filtered.length > 0 && (
        <div className="flex items-center justify-between border-t border-gray-200 px-5 py-4">
          <div className="text-sm text-gray-500">
            Showing {startIndex + 1} to {Math.min(endIndex, filtered.length)} of {filtered.length} entries
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
              aria-label="Previous page"
            >
              <ChevronLeft size={16} />
            </button>

            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={`h-8 min-w-8 rounded-md px-2 text-sm font-medium ${currentPage === pageNum
                    ? 'bg-primary-600 text-white'
                    : 'text-gray-700 hover:bg-surface-50'
                    }`}
                >
                  {pageNum}
                </button>
              );
            })}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-gray-200 text-gray-500 hover:bg-surface-50 disabled:cursor-not-allowed disabled:opacity-50"
              aria-label="Next page"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}